const styles = {
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: 2,
  },
  defaultButton: {
    color: 'text.primaryDark',
  },
  progress: {
    color: '#fff',
  },
  primaryButton: {
    width: '100%',
    pr: 0,
  },
}

export default styles
